import { ReactElement, ReactNode, MouseEventHandler } from 'react'

import classNames from 'classnames'
import noop from 'lodash/noop'

import { Flex } from 'components/core'

import * as styles from './styles.scss'

interface Props {
    children?: ReactNode
    icon?: ReactNode
    onClick?: MouseEventHandler
    className?: string
    link?: boolean
    disabled?: boolean
    inline?: boolean
}

const TextButton = ({
    children = null,
    icon = null,
    onClick = noop,
    className = '',
    link = false,
    disabled = false,
    inline = false,
}: Props): ReactElement => {
    return (
        <Flex
            inline={inline}
            gap={10}
            className={classNames(className, {
                [styles.button]: !disabled,
                [styles.disabled]: disabled,
                [styles.link]: link,
            })}
            onClick={disabled ? undefined : onClick}
            role="button"
            aria-disabled={disabled}
            tabIndex={-1}
            onKeyPress={noop}
        >
            {icon}
            {children && <span>{children}</span>}
        </Flex>
    )
}

export default TextButton
